import React from 'react'
import PdaTitle from '../common/PdaTitle'
import LogoDark from '../common/LogoDark'
import { PdaMenuItem } from '../../types/common'
import MenuLink from '../common/MenuLink'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const InventoryMenu = () => {
    const { t } = useTranslation()
    const menus: PdaMenuItem[] = [
        {
            name: t(tokens.inventory.slow_moving_inventory_location),
            uri: '/sluggish-inventory-location',
        },
        {
            name: t(tokens.inventory.scheduled_disposal_location),
            uri: '/abrogation-expected-location',
        },
        {
            name: t(tokens.inventory.unused_location),
            uri: '/unused-location',
        },
        {
            name: t(tokens.inventory.incoming_location),
            uri: '/inbound-location',
        },
        {
            name: t(tokens.inventory.picking_location),
            uri: '/picking-location',
        },
        {
            name: t(tokens.inventory.takeback_location),
            uri: '/takeback-location',
        },
        {
            name: t(tokens.inventory.return_location),
            uri: '/return-location',
        },
    ]

    return (
        <>
            <MenuLink items={menus} color="" />
        </>
    )
}

export default InventoryMenu
